import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";
import {PieceJointe} from "../../ui/heures-insertion-dashboard/piece-jointe-modal/piece-jointe-modal.component";
import {PieceJointeSaveDto} from "./dto/piece-jointe-save.dto";
import {environment} from "../../../../environments/environment";

@Injectable({providedIn: 'root'})
export class InsertionChantierPieceJointeHttp {
  private static endpoint = environment.baseUrl + '/piecejointe/insertion-chantier'
  private http = inject(HttpClient)

  getPieceJointeByInsertionChantierIdAndPeriode(idInsertionChantier: number, periode: string): Observable<PieceJointe[]> {
    return this.http.get<PieceJointe[]>(`${InsertionChantierPieceJointeHttp.endpoint}/find/${idInsertionChantier}/${periode}`)
  }

  uploadPieceJointeInsertionChantier(idInsertionChantier: number, periode: string, pieceJointeSaveDto: PieceJointeSaveDto): Observable<PieceJointe> {
    const url = `${InsertionChantierPieceJointeHttp.endpoint}/save/${idInsertionChantier}/${periode}`

    return this.http.post<PieceJointe>(url, pieceJointeSaveDto).pipe(
      catchError(err => {
        console.error('[GLOBAL PIECE JOINTE UPLOAD FAILED]', err)
        return throwError(() => new Error(`Échec de l'ajout de la pièce jointe: ${err.message}`))
      })
    )
  }
}
